import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import {Grid, IconButton} from '@mui/material';

type CompanyProfileImageUploadProps = {
  onChange: (e: any) => void;
};

export default function CompanyProfileImageUpload({onChange}: CompanyProfileImageUploadProps) {
  return (
    <Grid>
      <input accept='image/*' id='media-image-upload' type='file' style={{display: 'none'}} onChange={onChange} />
      <label htmlFor='media-image-upload'>
        <IconButton aria-label='upload picture' component='span'>
          <PhotoCameraIcon />
        </IconButton>
      </label>
    </Grid>
  );
}
